// AgentVerse/common/schemas/collections/agentVerseInferenceLogs.js
import { z } from "zod";

const InferenceLogSchema = z.object({
    _id: z.string().optional(),
    timestamp: z.date(),
    model: z.string(),
    provider: z.string(),
    modality: z.string(),
    durationMs: z.number(),
    status: z.string(), // "success" | "error"
    requestSummary: z.any().optional(), // Or a more defined summary schema
    responseSummary: z.any().optional(),
    usage: z.object({
        prompt_tokens: z.number().optional(),
        completion_tokens: z.number().optional(),
        total_tokens: z.number().optional(),
        // Add other usage metrics like image_count, audio_duration_seconds if relevant
    }).optional().nullable(),
    cost: z.number().optional().nullable(),
    error: z.string().optional().nullable(),
    // Context fields logged based on hook options
    userId: z.string().optional(),
    projectId: z.string().optional(),
    serviceCode: z.string().optional(),
    requestId: z.string().optional(),
});

export default InferenceLogSchema;